export default __webpack_public_path__ + "static/media/cover_abwaab.2aabd0ca.png";